<template>
  <div class="bg-white p-2">
    <template v-if="!isLoading && pagination && pagination.docs.length > 0">
      <template v-if="datasourceInventoryAtleastShowed">
        <right-panel class="float-right" id="sidebar-new-datasource-direct-collect-method" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceDirectCollectMethodForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-other-collect-method" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceOtherCollectMethodForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-physical-archive" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourcePhysicalArchiveForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-electronic-archive" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceElectronicArchiveForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-physical-storage" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourcePhysicalStorageForm id="sidebar-new-datasource-physical-storage" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-electronic-storage" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceElectronicStorageForm />
          </div>
        </right-panel>
      </template>

      <template v-if="dataInventoryAtleastShowed">
        <right-panel class="float-right" id="sidebar-new-data-disposal-method" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DataDisposalMethodForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-data-disposal-period" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DataDisposalPeriodForm id="sidebar-data-disposal-period" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-data-access-and-restriction" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DataAccessAndRestrictionForm id="sidebar-new-data-access-and-restriction" />
          </div>
        </right-panel>
      </template>

      <template v-if="datasubjectInventoryAtleastShowed">
        <right-panel class="float-right" id="sidebar-new-datasubject-transfering" width="1250px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectTransferingForm id="sidebar-new-datasubject-transfering" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasubject-processing-legal" width="1000px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectProcessingLegalForm id="sidebar-new-datasubject-processing-legal" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasubject-auto-processing" width="1000px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DataSubjectAutoProcessingForm id="sidebar-new-datasubject-auto-processing" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasubject-datasubject-right" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectDatasubjectRightForm />
          </div>
        </right-panel>
      </template>
    </template>

    <div class="float-right d-flex">
      <b-dropdown split split-href="#" :text="$t('inventory.options')" size="sm" variant="light" class="m-2">
        <b-dropdown-item @click="downloadInventory()" href="#">{{ $t("common.download") }}</b-dropdown-item>
        <b-dropdown-item @click="downloadInventory(true)" href="#">{{ $t("inventory.save-to-files") }}</b-dropdown-item>
      </b-dropdown>

      <InventoryFilter id="sidebar-inventory-filter" @apply="paginate" />
      <BulkUpdate @applyFilter="paginate" />

      <sweet-button @click="fullscreen = true" variant="main" icon="bx bx-expand" size="sm" buttonClass="ml-3  mt-2">
        {{ $t("common.fullscreen") }}
      </sweet-button>
    </div>

    <!---->
    <div class="float-left pb-2">
      <b-form-checkbox switch size="sm" v-model="columnOptions.datasourceInventory.show" :disabled="isColumnOptionsDisabled">
        {{ $t("inventory.datasource-features") }}
      </b-form-checkbox>

      <b-form-checkbox switch size="sm" v-model="columnOptions.dataInventory.show" :disabled="isColumnOptionsDisabled">
        {{ $t("inventory.data-features") }}
      </b-form-checkbox>

      <b-form-checkbox switch size="sm" v-model="columnOptions.datasubjectInventory.show" :disabled="isColumnOptionsDisabled">
        {{ $t("inventory.datasubject-features") }}
      </b-form-checkbox>
    </div>
    <br style="clear:both" />

    <div :style="inventoryShowing ? 'overflow:auto' : ''" style="max-height:100vh" class="inventory-table" :class="fullscreen ? 'fullscreen' : ''">
      <button class="btn btn-sm btn-main btn-exit" v-if="fullscreen" @click="fullscreen = false">{{ $t("common.close") }}</button>
      <div v-if="!isLoading && pagination" :style="tableStyle" class="tableContainer">
        <b-row class="font-size-11 pt-1 mb-0" :class="fullscreen ? 'sticky-header-fs' : 'sticky-header'">
          <b-col :md="md1Or2" class="sticky sticky-col-1 bg-light ">
            <div class="pt-2">
              <div>{{ $t("department.text") }}</div>
            </div>
          </b-col>
          <b-col :md="md10Or11">
            <b-row>
              <b-col :md="md1Or2" class="sticky sticky-col-2 bg-light">
                <div class="pt-2">
                  {{ $t("process.text") }}
                </div>
              </b-col>
              <b-col :md="md10Or11">
                <b-row>
                  <b-col :md="md1Or2" class="sticky sticky-col-3 bg-light">
                    <div class="pt-2">
                      {{ $t("datasource.text") }}
                    </div>
                  </b-col>
                  <b-col :md="columnOptions.dataInventory.show || columnOptions.datasubjectInventory.show ? '11' : '5'" v-if="columnOptions.data.show">
                    <b-row>
                      <b-col :md="mdDataCategory" class="bg-light sticky sticky-col-4">
                        <div class="pt-2">
                          {{ $t("data-category.text") }}
                        </div>
                      </b-col>
                      <b-col :md="mdData" class="bg-light">
                        <b-row>
                          <b-col
                            :md="columnOptions.datasubjectInventory.show ? '1' : columnOptions.dataInventory.show ? '2' : '6'"
                            class="sticky sticky-col-5 bg-light"
                            marker="data"
                          >
                            <div class="p-2">
                              {{ $t("data.text") }}
                            </div>
                          </b-col>
                          <b-col
                            v-if="!inventoryShowing || columnOptions.datasubjectInventory.show"
                            :md="columnOptions.datasubjectInventory.show ? '11' : columnOptions.dataInventory.show ? '1' : '6'"
                            marker="datasubject"
                          >
                            <b-row>
                              <b-col :md="md1Or12" class="sticky sticky-col-6 bg-light">
                                <div class="p-2">
                                  {{ $t("datasubject.text") }}
                                </div>
                              </b-col>

                              <template v-if="columnOptions.datasubjectInventory.show">
                                <b-col md="5" class="bg-soft-inventory">
                                  <b-row>
                                    <b-col class="text-center">{{ $t("processing.text") }}</b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col md="5">{{ $t("processing-transfering.purpose.text") }}</b-col>
                                    <b-col md="5">{{ $t("processing-transfering.reason-and-interest-alt") }}</b-col>
                                    <b-col md="2"> {{ $t("processing.auto") }}</b-col>
                                  </b-row>
                                </b-col>

                                <b-col md="5" class="bg-inventory">
                                  <b-row>
                                    <b-col class="text-center">{{ $t("transfering.text") }}</b-col>
                                  </b-row>

                                  <b-row>
                                    <b-col>{{ $t("processing-transfering.purpose.text") }}</b-col>
                                    <b-col>{{ $t("processing-transfering.reason-and-interest-alt") }}</b-col>
                                    <b-col>{{ $t("transfering.method.text") }}</b-col>
                                    <b-col>{{ $t("transfering.prevention.lean") }}</b-col>
                                  </b-row>
                                </b-col>

                                <b-col md="1" class="bg-soft-inventory">
                                  <b-row>
                                    <b-col>{{ $t("datasubject-right.text") }}</b-col>
                                  </b-row>
                                </b-col>
                              </template>
                            </b-row>
                          </b-col>

                          <template v-if="columnOptions.dataInventory.show">
                            <b-col md="5" class="bg-soft-inventory">
                              <b-row>
                                <b-col class="text-center p-2">
                                  {{ $t("disposal-method.title") }}
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col class="text-center">
                                  {{ $t("disposal-method.text") }}
                                </b-col>
                                <b-col class="text-center">
                                  {{ $t("disposal-method.periodic") }}
                                </b-col>
                              </b-row>
                            </b-col>

                            <b-col md="5" class="bg-inventory">
                              <b-row>
                                <b-col class="text-center p-2">
                                  {{ $t("accessing-persons.text") }}
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col class="text-center">
                                  {{ $t("accessing-persons.name") }}
                                </b-col>
                                <b-col class="text-center">
                                  {{ $t("access-restriction.permission") }}
                                </b-col>
                              </b-row>
                            </b-col>
                          </template>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>

                  <template v-if="columnOptions.datasourceInventory.show">
                    <b-col class="bg-soft-inventory">
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("collect-method.text") }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("collect-method.direct") }}
                        </b-col>
                        <b-col class="text-center">
                          {{ $t("collect-method.other") }}
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col class="bg-inventory">
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("storage-environments.text") }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("storage-environments.physical") }}
                        </b-col>

                        <b-col class="text-center">
                          {{ $t("storage-environments.electronic") }}
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col class="bg-soft-inventory">
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("archive-environments.text") }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="text-center">
                          {{ $t("archive-environments.physical") }}
                        </b-col>
                        <b-col class="text-center">
                          {{ $t("archive-environments.electronic") }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-for="department in pagination.docs" :key="department._id" class="topLevel">
          <b-col :md="md1Or2" :id="department._id" class="sticky-col sticky-col-1 hider">
            <div class="p-2 stickyValue">
              {{ department.name | translate }}
              <inventory-note class="hidden" store="organizationDepartment" :payload="department" />
            </div>
          </b-col>
          <b-col :md="md10Or11">
            <b-row v-for="process in department.processes" :key="process._id">
              <b-col :md="md1Or2" :id="process._id" :parent="department._id" class="sticky-col sticky-col-2 hider">
                <div class="p-2 stickyValue">
                  {{ process.name | translate }}
                  <inventory-note class="hidden" store="organizationDepartmentProcess" :payload="process" />
                </div>
              </b-col>
              <b-col :md="md10Or11">
                <b-row v-for="datasource in process.datasources" :key="datasource._id">
                  <b-col :md="md1Or2" :id="datasource._id" :parent="process._id" class="sticky-col sticky-col-3 hider">
                    <div class="p-2 stickyValue">
                      {{ datasource.name | translate }}
                      <inventory-note class="hidden" store="organizationProcessDatasource" :payload="datasource" />
                    </div>
                  </b-col>
                  <b-col :md="columnOptions.dataInventory.show || columnOptions.datasubjectInventory.show ? '11' : '5'" v-if="columnOptions.data.show">
                    <b-row v-for="category in datasource.categories" :key="category._id">
                      <b-col
                        :md="mdDataCategory"
                        :id="category.combinedId"
                        level="category"
                        :datasource="datasource._id"
                        :parent="datasource._id"
                        class="sticky-col sticky-col-4 bg-white"
                      >
                        <div class="p-2 stickyValue">
                          {{ category.name | translate }}
                          <i v-if="category.specialQualityData" class="bx bx-info-circle text-primary" v-b-tooltip.hover :title="$t('data-category.special-quality-data')"></i>
                        </div>
                      </b-col>
                      <b-col :md="mdData">
                        <b-row v-for="data in category.datas" :key="data._id">
                          <b-col
                            :md="columnOptions.datasubjectInventory.show ? '1' : columnOptions.dataInventory.show ? '2' : '6'"
                            :id="data._id"
                            :datasource="datasource._id"
                            :data="data._id"
                            :parent="category.combinedId"
                            class="sticky-col sticky-col-5 bg-white hider"
                            marker="data"
                          >
                            <div class="p-2 stickyValue">
                              {{ data.name | translate }}
                              <inventory-note class="hidden" store="organizationDatasourceData" :payload="data" />
                            </div>
                          </b-col>
                          <b-col
                            v-if="!inventoryShowing || columnOptions.datasubjectInventory.show"
                            :md="columnOptions.datasubjectInventory.show ? '11' : columnOptions.dataInventory.show ? '1' : '6'"
                            marker="datasubject"
                          >
                            <b-row v-for="datasubject in data.datasubjects" :key="datasubject._id">
                              <b-col
                                :md="md1Or12"
                                :id="datasubject._id"
                                :datasource="datasource._id"
                                :data="data._id"
                                :parent="data._id"
                                level="datasubject"
                                class="sticky-col sticky-col-6 bg-white hider"
                              >
                                <div class="p-2 stickyValue">
                                  {{ datasubject.name | translate }}
                                  <inventory-note class="hidden" store="organizationDataDatasubject" :payload="datasubject" />
                                </div>
                              </b-col>

                              <template v-if="columnOptions.datasubjectInventory.show">
                                <b-col md="5" v-if="datasubjectInventory[datasubject._id]" :datasubject="datasubject._id" :parent="datasubject._id" class="sub-inventory hider">
                                  <b-row>
                                    <b-col md="10" :datasubject="datasubject._id" :parent="datasubject._id">
                                      <!---->

                                      <b-row
                                        v-for="processingLegal in datasubjectInventory[datasubject._id].processingLegals"
                                        :key="processingLegal._id"
                                        :datasubject="datasubject._id"
                                        :parent="datasubject._id"
                                      >
                                        <b-col md="6">
                                          <span class="text-danger hand hidden float-left" @click="deleteDatasubjectProcessingLegal(datasubject._id, processingLegal._id)">
                                            <i class="bx bx-trash"></i>
                                          </span>

                                          {{ processingLegal.purpose.name | translate }}
                                          <span v-if="processingLegal.legitimateInterest" class="text-muted">
                                            <br />
                                            <b>{{ $t("processing-transfering.legitimate-interest.text") }}:</b>{{ processingLegal.legitimateInterest | translate }}
                                          </span>
                                          <div v-if="!processingLegal.purpose.isVerbisPurpose && processingLegal.purpose.verbisAquivalent">
                                            <span class="text-muted float-left">
                                              <b>{{ $t("common.aquivalent-verbis") }}:</b>{{ processingLegal.purpose.verbisAquivalent.name | translate }}
                                            </span>
                                          </div>
                                        </b-col>
                                        <b-col md="6">
                                          {{ processingLegal.legalReason.name | translate }}
                                          <span v-if="processingLegal.legalReason.regulation" class="text-muted">
                                            <br />
                                            <b>{{ $t("common.regulation") }}:</b>{{ processingLegal.legalReason.regulation | translate }}
                                          </span>
                                        </b-col>
                                      </b-row>

                                      <span class="text-primary hand hidden" @click="createDatasubjectProcessingLegal(datasubject)">
                                        <i class="bx bx-plus"></i> {{ $t("common.add") }}
                                      </span>

                                      <span
                                        class="text-warning hand hidden ml-3"
                                        @click="editDatasubjectProcessingLegal(datasubject, datasubjectInventory[datasubject._id].processingLegals)"
                                      >
                                        <i class="bx bx-pencil"></i>
                                      </span>

                                      <!---->
                                    </b-col>

                                    <b-col md="2" :datasubject="datasubject._id" :parent="datasubject._id">
                                      <b-row>
                                        <b-col class="p-2">
                                          <span class="text-warning hand hidden float-right" @click="editAutoProcessing(datasubject, data, datasource, process, department)">
                                            <i class="bx bx-pencil"></i> {{ $t("common.edit") }}
                                          </span>
                                          {{ datasubject.feature.autoProcessing ? $t("common.yes") : $t("common.no") }}</b-col
                                        >
                                      </b-row>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col md="5" v-if="datasubjectInventory[datasubject._id]" :datasubject="datasubject._id" :parent="datasubject._id" class="sub-inventory hider">
                                  <div v-for="transfering in datasubjectInventory[datasubject._id].transferings" :key="transfering._id" class=" border-dark border mb-1">
                                    <b-row>
                                      <b-col>
                                        <b>{{ transfering.thirdParty.name | translate }}</b>

                                        <i v-if="transfering.thirdParty.country" class="text-muted">
                                          ({{ transfering.thirdParty.country.code != currentOrganization.country.code ? $t("thirdparty.abroad") : $t("thirdparty.domestic") }})
                                        </i>
                                      </b-col>
                                      <b-col>
                                        <b>{{ transfering.thirdParty.receiverGroup.name | translate }} </b>

                                        <span class="text-warning hand hidden float-right" @click="editDatasubjectTransfering(datasubject, transfering)">
                                          <i class="bx bx-pencil"></i> {{ $t("common.edit") }}
                                        </span>

                                        <span class="text-danger hand hidden float-right mr-2" @click="deleteDatasubjectTransfering(datasubject._id, transfering._id)">
                                          <i class="bx bx-trash"></i> {{ $t("common.delete") }}
                                        </span>
                                      </b-col>
                                    </b-row>

                                    <b-row>
                                      <b-col md="6">
                                        <b-row
                                          v-for="legal in transfering.legals"
                                          :key="transfering.thirdParty._id + legal.legalReason.libraryItem._id + legal.purpose.libraryItem._id + datasubject._id"
                                        >
                                          <b-col>
                                            {{ legal.purpose.name | translate }}
                                            <span v-if="legal.legitimateInterest" class="text-muted">
                                              <br />
                                              <b>{{ $t("processing-transfering.legitimate-interest.text") }}:</b>{{ legal.legitimateInterest | translate }}
                                            </span>
                                          </b-col>
                                          <b-col>
                                            {{ legal.legalReason.name | translate }}
                                            <span v-if="legal.legalReason.regulation" class="text-muted">
                                              <br />
                                              <b>{{ $t("common.regulation") }}:</b>{{ legal.legalReason.regulation | translate }}
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </b-col>

                                      <b-col>
                                        <ul>
                                          <li v-for="method in transfering.methods" :key="method._id + datasubject._id">
                                            {{ method.name | translate }}
                                          </li>
                                        </ul>
                                      </b-col>
                                      <b-col>
                                        <ul>
                                          <li v-for="prevention in transfering.preventions" :key="prevention._id + datasubject._id">
                                            {{ prevention.name | translate }}
                                          </li>
                                        </ul>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <b-row>
                                    <b-col class="p-2">
                                      <span class="text-primary hand hidden" @click="createDatasubjectTransfering(datasubject)">
                                        <i class="bx bx-plus"></i> {{ $t("common.add") }}
                                      </span>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col md="1" v-if="datasubjectInventory[datasubject._id]" :datasubject="datasubject._id" :parent="datasubject._id" class="sub-inventory">
                                  <b-row v-for="datasubjectRight in datasubjectInventory[datasubject._id].datasubjectRights" :key="datasubjectRight._id">
                                    <b-col>
                                      <i class="bx bx-trash text-danger hand hidden" @click="removeDatasubjectDatasubjectRigth(datasubject._id, datasubjectRight._id)"></i>

                                      {{ datasubjectRight.name | translate }}
                                    </b-col>
                                  </b-row>

                                  <b-row class="hidden">
                                    <b-col>
                                      <span class="text-primary hand" @click="addDatasubjectDatasubjectRight(datasubject)">
                                        <i class="bx bx-plus"></i> {{ $t("common.add") }}
                                      </span>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </template>
                            </b-row>
                            <b-row v-if="data.datasubjects.length == 0">
                              <b-col :md="columnOptions.datasubjectInventory.show ? '1' : '12'" level="datasubject" class="sticky-col sticky-col-6 bg-white">
                                <div class="p-2 stickyValue text-white">&nbsp;-</div>
                              </b-col>
                            </b-row>
                          </b-col>

                          <template v-if="columnOptions.dataInventory.show">
                            <b-col md="5" :data="data._id" :parent="data._id" class="sub-inventory">
                              <b-row v-if="dataInventory[data._id]">
                                <b-col class="hider">
                                  <b-row v-for="disposalMethod in dataInventory[data._id].disposalMethods" :key="disposalMethod._id">
                                    <b-col>
                                      <i class="bx bx-trash text-danger hand hidden" @click="removeDisposalMethod(data._id, disposalMethod._id)"></i>

                                      {{ disposalMethod.name | translate }}
                                    </b-col>
                                  </b-row>

                                  <b-row class="hidden">
                                    <b-col>
                                      <span class="text-primary hand" @click="editDisposalMethod(data)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                                    </b-col>
                                  </b-row>
                                </b-col>
                                <b-col>
                                  <span v-if="dataInventory[data._id]">
                                    {{ dataInventory[data._id].disposalPeriod | period }}
                                  </span>
                                  <br />
                                  <span class="text-warning hand" @click="editDisposalPeriod(data)"> <i class="bx bx-pencil"></i> {{ $t("common.edit") }} </span>
                                </b-col>
                              </b-row>
                            </b-col>

                            <b-col md="5" :data="data._id" :parent="data._id" class="sub-inventory hider">
                              <template v-if="dataInventory[data._id]">
                                <b-row v-for="(accessAndRestriction, index) in dataInventory[data._id].accessAndRestrictions" :key="accessAndRestriction._id + index">
                                  <b-col v-if="accessAndRestriction">
                                    <i class="bx bx-trash text-danger hand hidden" @click="removeAccessAndRestriction(data._id, accessAndRestriction._id)"></i>

                                    {{ accessAndRestriction.accessor.name | translate }}
                                  </b-col>
                                  <b-col v-if="accessAndRestriction">{{ accessAndRestriction.restriction.name | translate }}</b-col>
                                </b-row>
                              </template>
                              <b-row class="hidden">
                                <b-col>
                                  <span class="text-primary hand" @click="addAccessAndRestriction(data)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </template>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                  <template v-if="columnOptions.datasourceInventory.show">
                    <b-col :datasource="datasource._id" :parent="datasource._id" class="sub-inventory">
                      <b-row v-if="datasourceInventory[datasource._id]">
                        <b-col class="hider">
                          <b-row v-for="directCollectMethod in datasourceInventory[datasource._id].directCollectMethods" :key="directCollectMethod._id">
                            <b-col>
                              <i class="bx bx-trash text-danger hand hidden" @click="removeDirectCollectMethod(datasource._id, directCollectMethod._id)"></i>

                              {{ directCollectMethod.name | translate }}
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="editDirectCollectMethod(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col class="hider">
                          <b-row v-for="otherCollectMethod in datasourceInventory[datasource._id].otherCollectMethods" :key="otherCollectMethod._id">
                            <b-col>
                              <i class="bx bx-trash text-danger hand hidden" @click="removeOtherCollectMethod(datasource._id, otherCollectMethod._id)"></i>

                              {{ otherCollectMethod.name | translate }}
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="editOtherCollectMethod(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col :datasource="datasource._id" :parent="datasource._id" class="sub-inventory">
                      <b-row v-if="datasourceInventory[datasource._id]">
                        <b-col class="hider">
                          <b-row v-for="physicalStorage in datasourceInventory[datasource._id].physicalStorages" :key="physicalStorage._id">
                            <b-col>
                              <span class="text-warning hand hidden float-right" @click="editPhysicalStorage(datasource._id, physicalStorage)">
                                <i class="bx bx-pencil"></i>
                              </span>

                              <span class="text-danger hand hidden float-right mr-2" @click="removePhysicalStorage(datasource._id, physicalStorage._id)">
                                <i class="bx bx-trash"></i>
                              </span>

                              {{ physicalStorage.name | translate }} <span class="text-muted"> - {{ physicalStorage.period | period }}</span>
                              <br />
                              <i class="text-muted">
                                {{ physicalStorage.since }}
                              </i>
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="addPhysicalStorage(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col class="hider">
                          <b-row v-for="electronicStorage in datasourceInventory[datasource._id].electronicStorages" :key="electronicStorage._id">
                            <b-col>
                              <span class="text-warning hand hidden float-right" @click="editElectronicStorage(datasource._id, electronicStorage)">
                                <i class="bx bx-pencil"></i>
                              </span>

                              <span class="text-danger hand hidden float-right mr-2" @click="removeElectronicStorage(datasource._id, electronicStorage._id)">
                                <i class="bx bx-trash"></i>
                              </span>

                              {{ electronicStorage.name | translate }} <span class="text-muted"> - {{ electronicStorage.period | period }}</span>
                              <br />
                              <i class="text-muted">
                                {{ electronicStorage.since }}
                              </i>
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="addElectronicStorage(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col :datasource="datasource._id" :parent="datasource._id" class="sub-inventory">
                      <b-row v-if="datasourceInventory[datasource._id]">
                        <b-col class="hider">
                          <b-row v-for="physicalArchive in datasourceInventory[datasource._id].physicalArchives" :key="physicalArchive._id">
                            <b-col>
                              <i class="bx bx-trash text-danger hand hidden" @click="removePhysicalArchive(datasource._id, physicalArchive._id)"></i>

                              {{ physicalArchive.name | translate }}
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="editPhysicalArchive(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col class="hider">
                          <b-row v-for="electronicArchive in datasourceInventory[datasource._id].electronicArchives" :key="electronicArchive._id">
                            <b-col>
                              <i class="bx bx-trash text-danger hand hidden" @click="removeElectronicArchive(datasource._id, electronicArchive._id)"></i>

                              {{ electronicArchive.name | translate }}
                            </b-col>
                          </b-row>

                          <b-row class="hidden">
                            <b-col>
                              <span class="text-primary hand" @click="editElectronicArchive(datasource)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-9 pt-5">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="20" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("common.not-found") }}
      </h5>
    </empty>
  </div>
</template>

<script>
import DataAccessAndRestrictionForm from "@modules/inventory/component/access-and-restriction/data-access-and-restriction-form";
import BulkUpdate from "@modules/inventory/component/bulk-update/bulk-update";
import DatasubjectDatasubjectRightForm from "@modules/inventory/component/datasubject-right/datasubject-datasubject-right-form";
import DatasourceDirectCollectMethodForm from "@modules/inventory/component/direct-collect-method/datasource-direct-collect-method-form";
import DataDisposalMethodForm from "@modules/inventory/component/disposal-method/data-disposal-method-form";
import DataDisposalPeriodForm from "@modules/inventory/component/disposal-period/data-disposal-period-form";
import DatasourceElectronicArchiveForm from "@modules/inventory/component/electronic-archive/datasource-electronic-archive-form";
import DatasourceElectronicStorageForm from "@modules/inventory/component/electronic-storage/datasource-electronic-storage-form";
import InventoryFilter from "@modules/inventory/component/filter/inventory-filter";
import DatasourceOtherCollectMethodForm from "@modules/inventory/component/other-collect-method/datasource-other-collect-method-form";
import DatasourcePhysicalArchiveForm from "@modules/inventory/component/physical-archive/datasource-physical-archive-form";
import DatasourcePhysicalStorageForm from "@modules/inventory/component/physical-storage/datasource-physical-storage-form";
import DataSubjectAutoProcessingForm from "@modules/inventory/component/processing/datasubject-auto-processing-form";
import DatasubjectProcessingLegalForm from "@modules/inventory/component/processing/datasubject-legal-form";
import DatasubjectTransferingForm from "@modules/inventory/component/transfering/datasubject-transfering-form";
import { EventBus } from "@modules/websocket";
import InventoryNote from "./component/inventory-note.vue";

export default {
  props: ["product"],
  components: {
    DatasourceDirectCollectMethodForm,
    DatasourceOtherCollectMethodForm,
    DatasourcePhysicalArchiveForm,
    DatasourceElectronicArchiveForm,
    DataDisposalMethodForm,
    DataDisposalPeriodForm,
    DatasourcePhysicalStorageForm,
    DataAccessAndRestrictionForm,
    DatasourceElectronicStorageForm,
    DatasubjectTransferingForm,
    DatasubjectProcessingLegalForm,
    DatasubjectDatasubjectRightForm,
    InventoryFilter,
    DataSubjectAutoProcessingForm,
    BulkUpdate,
    InventoryNote,
  },
  data() {
    return {
      fullscreen: false,
      hoveredItem: null,
      columnOptions: { data: { show: true }, datasourceInventory: { show: false }, dataInventory: { show: false }, datasubjectInventory: { show: false } },
      request: {
        options: { page: 1, limit: 50, sort: { name: "asc" } },
        query: {},
      },

      datasourceInventoryAtleastShowed: false,
      datasubjectInventoryAtleastShowed: false,
      dataInventoryAtleastShowed: false,
    };
  },
  computed: {
    productInventoryStore() {
      return this.product == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
    pagination() {
      return this.$store.getters[this.productInventoryStore + "/pagination"];
    },
    isLoading() {
      return this.$store.getters[this.productInventoryStore + "/isLoading"];
    },
    dataInventory() {
      return this.$store.getters[this.productInventoryStore + "/dataInventory"];
    },
    isDataInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDataInventoryLoading"];
    },
    datasourceInventory() {
      return this.$store.getters[this.productInventoryStore + "/datasourceInventory"];
    },
    isDatasourceInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDatasourceInventoryLoading"];
    },
    isDatasubjectInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDatasubjectInventoryLoading"];
    },
    datasubjectInventory() {
      return this.$store.getters[this.productInventoryStore + "/datasubjectInventory"];
    },
    isColumnOptionsDisabled() {
      return this.isLoading || this.isDatasourceInventoryLoading || this.isDatasubjectInventoryLoading;
    },

    inventoryShowing() {
      return this.columnOptions.datasourceInventory.show || this.columnOptions.dataInventory.show || this.columnOptions.datasubjectInventory.show;
    },
    md1Or2() {
      return this.inventoryShowing ? "1" : "3";
    },
    mdDataCategory() {
      return this.inventoryShowing ? "2" : "3";
    },
    md1Or12() {
      if (this.columnOptions.datasubjectInventory.show) {
        return "1";
      }
      return this.columnOptions.dataInventory.show || this.columnOptions.data.show ? "12" : "1";
    },
    md10Or11() {
      return this.inventoryShowing ? "11" : "9";
    },
    mdData() {
      return this.inventoryShowing ? "10" : "9";
    },
    tableStyle() {
      const o = this.columnOptions;

      if (o.datasourceInventory.show) {
        return "min-width:1300px";
      }

      if (o.dataInventory.show) {
        return "min-width:1300px";
      }

      if (o.datasubjectInventory.show) {
        return "min-width:2500px";
      }
      return "";
    },
  },
  watch: {
    "columnOptions.datasourceInventory.show": {
      handler(v) {
        if (v) {
          this.columnOptions.dataInventory.show = false;
          this.columnOptions.datasubjectInventory.show = false;
          this.columnOptions.data.show = false;
          this.fetchDatasourceInventory();

          this.datasourceInventoryAtleastShowed = true;
        } else {
          this.columnOptions.data.show = true; //bu satır olmazsa veri konusu kişi görünmüyor.
        }
      },
    },
    "columnOptions.dataInventory.show": {
      handler(v) {
        if (v) {
          this.columnOptions.datasourceInventory.show = false;
          this.columnOptions.datasubjectInventory.show = false;
          this.columnOptions.data.show = true;
          this.fetchDataInventory();

          this.dataInventoryAtleastShowed = true;
        }
      },
    },
    "columnOptions.datasubjectInventory.show": {
      handler(v) {
        if (v) {
          this.columnOptions.datasourceInventory.show = false;
          this.columnOptions.dataInventory.show = false;
          this.columnOptions.data.show = true;
          this.fetchDatasubjectInventory();

          this.datasubjectInventoryAtleastShowed = true;
        }
      },
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },
  mounted() {
    EventBus.$on("sync", (data) => {
      if (data?.bulkUpdateProcessDone) {
        if (data?.organization._id == this.currentOrganization._id) {
          if (data.refreshRequired) {
            this.paginate();
          } else {
            this.onBulkUpdated();
          }
        }
      }
    });

    // this.paginate();
    //Scroll ettiğinde major kolonlar küçülmesi için
    // document
    //   .querySelector(".inventory-table")
    //   .addEventListener("scroll", (event) => document.querySelectorAll(".sticky,.sticky-col").forEach(this.widthCallback), { passive: true });
  },
  methods: {
    async paginate() {
      try {
        await this.$store.dispatch(this.productInventoryStore + "/paginateWith", { pagination: this.request, criteria: this.criteria });
        this.initHover();
        if (this.columnOptions.datasubjectInventory.show) {
          this.fetchDatasubjectInventory();
        } else if (this.columnOptions.dataInventory.show) {
          this.fetchDataInventory();
        } else if (this.columnOptions.datasourceInventory.show) {
          this.fetchDatasourceInventory();
        }
      } catch (error) {
        console.error(error);
      }
    },
    onBulkUpdated() {
      //burada websocketlerin geri bildirimi ile yapılması gereken işlemler olmalı.
      if (this.columnOptions.datasubjectInventory.show) {
        this.fetchDatasubjectInventory();
      } else if (this.columnOptions.dataInventory.show) {
        this.fetchDataInventory();
      } else if (this.columnOptions.datasourceInventory.show) {
        this.fetchDatasourceInventory();
      }
    },

    widthCallback(x) {
      const it = document.querySelector(".inventory-table");
      // if (it.scrollLeft > 0) {
      x.classList.add("mw-80");
      const y = x.querySelectorAll("div");
      y.forEach((z) => {
        z.style.cssText = "justify-content: flex-start !important; max-width: 80px !important";
      });
      // } else {
      //   x.classList.remove("mw-80");
      //   x.querySelector("div").style.cssText = "justify-content: center !important";
      // }
    },
    initHover() {
      const divs = document.querySelectorAll(".topLevel *");
      divs.forEach((b) => {
        b.addEventListener("mouseover", (e) => {
          document.querySelectorAll(".highlight,.highlight-dark").forEach((i) => i.classList.remove("highlight", "highlight-dark"));
          let el = e.target;
          if (!el.attributes["parent"]) {
            el = el.closest("[parent]");
          }
          if (!el) {
            return;
          }
          let parentId = el.attributes["parent"].value;

          [
            ...(el.attributes["level"]?.value == "category" ? [] : document.querySelectorAll("[datasource='" + parentId + "']")),
            ...(el.attributes["level"]?.value == "datasubject" ? [] : document.querySelectorAll("[data='" + parentId + "']")),
            ...document.querySelectorAll("[datasubject='" + parentId + "']"),
          ].forEach((i) => i.classList.add("highlight"));

          el.classList.add("highlight-dark");
          let parent = document.querySelector("[id='" + parentId + "']");
          while (parent) {
            parent.classList.add("highlight");
            parent = document.querySelector("[id='" + parent.attributes["parent"]?.value + "']");
          }
        });
        b.addEventListener("mouseleave", (e) => {
          document.querySelectorAll(".highlight,.highlight-dark").forEach((i) => i.classList.remove("highlight", "highlight-dark"));
        });
      });
    },

    //
    async fetchDataInventory() {
      if (!this.pagination) return;

      const datas = [];
      for (const department of this.pagination?.docs) {
        for (const process of department.processes) {
          for (const datasource of process.datasources) {
            for (const category of datasource.categories) {
              for (const data of category.datas) {
                datas.push({ _id: data._id });
              }
            }
          }
        }
      }
      try {
        await this.$store.dispatch(this.productInventoryStore + "/fetchDataInventory", { datas });
      } catch (error) {}
    },

    async fetchDatasourceInventory() {
      if (!this.pagination) return;

      const datasources = [];
      for (const department of this.pagination?.docs) {
        for (const process of department.processes) {
          for (const datasource of process.datasources) {
            datasources.push({ _id: datasource._id });
          }
        }
      }
      try {
        await this.$store.dispatch(this.productInventoryStore + "/fetchDatasourceInventory", { datasources });
      } catch (error) {}
    },

    async fetchDatasubjectInventory() {
      if (!this.pagination) return;

      const datasubjects = [];
      for (const department of this.pagination?.docs) {
        for (const process of department.processes) {
          for (const datasource of process.datasources) {
            for (const category of datasource.categories) {
              for (const data of category.datas) {
                for (const datasubject of data.datasubjects) {
                  datasubjects.push({ _id: datasubject._id });
                }
              }
            }
          }
        }
      }
      try {
        await this.$store.dispatch(this.productInventoryStore + "/fetchDatasubjectInventory", { datasubjects });
      } catch (error) {}
    },

    editDirectCollectMethod(datasource) {
      this.$store.commit("datasourceDirectCollectMethod/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-direct-collect-method");
    },

    async removeDirectCollectMethod(datasourceId, directCollectMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceDirectCollectMethod/delete", directCollectMethodId);
        this.$store.commit(this.productInventoryStore + "/removeDirectCollectMethod", { datasourceId, directCollectMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editOtherCollectMethod(datasource) {
      this.$store.commit("datasourceOtherCollectMethod/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-other-collect-method");
    },

    async removeOtherCollectMethod(datasourceId, otherCollectMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceOtherCollectMethod/delete", otherCollectMethodId);
        this.$store.commit(this.productInventoryStore + "/removeOtherCollectMethod", { datasourceId, otherCollectMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editPhysicalArchive(datasource) {
      this.$store.commit("datasourcePhysicalArchive/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-archive");
    },

    async removePhysicalArchive(datasourceId, physicalArchiveId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourcePhysicalArchive/delete", physicalArchiveId);
        this.$store.commit(this.productInventoryStore + "/removePhysicalArchive", { datasourceId, physicalArchiveId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editElectronicArchive(datasource) {
      this.$store.commit("datasourceElectronicArchive/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-archive");
    },

    async removeElectronicArchive(datasourceId, electronicArchiveId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceElectronicArchive/delete", electronicArchiveId);
        this.$store.commit(this.productInventoryStore + "/removeElectronicArchive", { datasourceId, electronicArchiveId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDisposalMethod(data) {
      this.$store.commit("dataDisposalMethod/editedData", data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-disposal-method");
    },

    async removeDisposalMethod(dataId, disposalMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("dataDisposalMethod/delete", disposalMethodId);
        this.$store.commit(this.productInventoryStore + "/removeDisposalMethod", { dataId, disposalMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    editDisposalPeriod(data) {
      this.$store.commit("dataDisposalPeriod/editedData", data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-data-disposal-period");
    },

    addPhysicalStorage(datasource) {
      this.$store.commit("datasourcePhysicalStorage/editedDatasource", datasource);
      this.$store.commit("datasourcePhysicalStorage/editedPhysicalStorage", {});
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-storage");
    },
    editPhysicalStorage(datasource, storage) {
      this.$store.commit("datasourcePhysicalStorage/editedDatasource", datasource);
      this.$store.commit("datasourcePhysicalStorage/editedPhysicalStorage", storage);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-storage");
    },

    async removePhysicalStorage(datasourceId, physicalStorageId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourcePhysicalStorage/delete", physicalStorageId);
        this.$store.commit(this.productInventoryStore + "/removePhysicalStorage", { datasourceId, physicalStorageId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    addElectronicStorage(datasource) {
      this.$store.commit("datasourceElectronicStorage/editedDatasource", datasource);
      this.$store.commit("datasourceElectronicStorage/editedElectronicStorage", {});
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-storage");
    },
    editElectronicStorage(datasource, storage) {
      this.$store.commit("datasourceElectronicStorage/editedDatasource", datasource);
      this.$store.commit("datasourceElectronicStorage/editedElectronicStorage", storage);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-storage");
    },

    async removeElectronicStorage(datasourceId, electronicStorageId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceElectronicStorage/delete", electronicStorageId);
        this.$store.commit(this.productInventoryStore + "/removeElectronicStorage", { datasourceId, electronicStorageId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDatasubjectTransfering(datasubject, transfering) {
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", transfering);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    createDatasubjectTransfering(datasubject) {
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    async deleteDatasubjectTransfering(datasubjectId, transferingId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectTransfering/delete", transferingId);
        this.$store.commit(this.productInventoryStore + "/removeTransfering", { datasubjectId, transferingId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDatasubjectProcessingLegal(datasubject, processings) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", processings);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    editAutoProcessing(datasubject, data, datasource, process, department) {
      const enRicheddatasubject = { ...datasubject, data: { ...data, datasource: { ...datasource, process: { ...process, department: { ...department } } } } };

      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", enRicheddatasubject);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-auto-processing");
    },
    createDatasubjectProcessingLegal(datasubject) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", null);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    async deleteDatasubjectProcessingLegal(datasubjectId, processingLegalId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectProcessingLegal/delete", processingLegalId);
        this.$store.commit(this.productInventoryStore + "/removeProcessingLegal", { datasubjectId, processingLegalId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    addDatasubjectDatasubjectRight(item) {
      this.$store.commit("datasubjectDatasubjectRight/editedDatasubject", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-datasubject-right");
    },

    async removeDatasubjectDatasubjectRigth(datasubjectId, datasubjectDatasubjectRightId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectDatasubjectRight/delete", datasubjectDatasubjectRightId);
        this.$store.commit(this.productInventoryStore + "/removeDatasubjectDatasubjectRigth", { datasubjectId, datasubjectDatasubjectRightId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    addAccessAndRestriction(item) {
      this.$store.commit("dataAccessAndRestriction/editedData", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-access-and-restriction");
    },

    async removeAccessAndRestriction(dataId, accessAndRestrictionId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("dataAccessAndRestriction/delete", accessAndRestrictionId);
        this.$store.commit(this.productInventoryStore + "/removeAccessAndRestriction", { dataId, accessAndRestrictionId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      if (this.columnOptions.datasourceInventory.show) {
        this.fetchDatasourceInventory();
      } else if (this.columnOptions.datasubjectInventory.show) {
        this.fetchDatasubjectInventory();
        this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
        this.$store.commit("datasubjectTransfering/editedDatasubject", null);
      } else if (this.columnOptions.dataInventory.show) {
        this.fetchDataInventory();
      }
      this.$store.commit("datasubjectProcessingLegal/showRecommendations", false);
      this.$store.commit("datasubjectTransfering/showRecommendations", false);
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadInventory(saveInsteadofDownload = false) {
      let ok = true;
      if (saveInsteadofDownload) {
        ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        const { data: file } = await this.$store.dispatch(`gdprInventory/download`, saveInsteadofDownload);
        if (!saveInsteadofDownload) {
          this.download(file);
        }

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.border-light {
  border: 0.01em solid rgb(144, 144, 144) !important;
}

.topLevel .row > div:nth-child(1):not(.sub-table div):not(.sub-inventory div) {
  // border: 0.01em solid rgb(221 221 221);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.topLevel {
  border-bottom: 1px solid rgb(221 221 221);
}

.topLevel div {
  font-size: 10px;
}

.sub-table table {
  min-width: 200px;
}

.sub-table table td,
.sub-table table th {
  padding: 4px !important;
}

.sub-inventory div {
  // border: 0.01em solid rgb(234, 234, 234);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.highlight {
  background-color: rgb(246, 251, 255) !important;
}
.highlight-dark {
  background-color: rgb(233, 246, 255) !important;
}

.sticky,
.sticky-col {
  width: 150px;
  position: sticky;
  z-index: 1;
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;

  .stickyValue {
    position: sticky;
    top: 40px;
  }

  // div {
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
}

.sticky-col {
  background-color: white;
}

.sticky-col-1 {
  left: 0px;
}

.sticky-col-2 {
  left: 80px;
}

.sticky-col-3 {
  left: 160px;
}

.sticky-col-4 {
  left: 240px;
}

.sticky-col-5 {
  left: 320px;
}

.sticky-col-6 {
  left: 440px;
}

.fullscreen {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: auto;
  background-color: white;
  z-index: 1001;
}

.btn-exit {
  position: fixed;
  right: 1rem;
  top: 1rem;
  z-index: 999;
}

.bg-soft-inventory {
  background-color: rgb(240, 229, 253);
}

.bg-inventory {
  background-color: rgb(228, 206, 255);
}

.bg-soft-secondary {
  background-color: rgb(222, 222, 222) !important;
}

.sticky-header {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.sticky-header-fs {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.col ul {
  padding-left: 15px;
  margin: 0px;
}
</style>
